module.exports = __webpack_public_path__ + "static/300-genesis-50f699f38e824743290c3dd3f6d9bb45.png";